import { makeStyles } from "@material-ui/core/styles";
import { grey300 } from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "40vw",
  },
  row: {
    paddingBottom: theme.spacing(3),
  },
  buttonRow: {
    "& button": {
      margin: `0 ${theme.spacing(1)}px`,
    },
  },
  textArea: {
    width: "100%",
    border: `solid 1px ${grey300}`,
    borderRadius: 4,
    padding: theme.spacing(1),
    minHeight: 100,
    fontSize: theme.typography.body2,
  },
}));

export default useStyles;
